import axios from 'axios'
import store from '@/store/index.js'
import { filterEmptyKey } from '@/utils/util.js'
import { Message } from 'element-ui'
import router from '@/router/index'

axios.defaults.headers = {
  'content-type': 'application/json'
}
axios.tempGet = axios.get
axios.defaults.timeout = 30000
axios.get = (url, data, config) => {
  data = data || {}
  if (!data.isCad) {
    data.isCad = store.getters.isCad
  }
  return axios.tempGet(url, { params: data, ...config })
}

const whiteList = [] // 不需要登录的接口地址
axios.interceptors.request.use(config => {
  // 处理请求参数，统一将参数放入data，以便适配器操作
  if (config.method === 'get') {
    config.params = filterEmptyKey(config.params)
  }
  config.headers.token = store.state.token
  config.headers.customer = store.state.customer
  return config
}, error => {
  return Promise.reject(error)
})

// 添加响应拦截器
axios.interceptors.response.use(res => {
  if (res.status !== 200) {
    Message({ type: 'error', message: '数据加载失败，请稍后再试' })
    return Promise.reject(new Error(res.data))
  }
  if (res.data instanceof Blob) {
    const head = res.headers['content-disposition']
    let fname = ''
    if (head) {
      try {
        const info = head.split(';')
        info.forEach(item => {
          if (item.indexOf('filename') >= 0) {
            fname = item.split('=')[1]
            const reg = /"/g
            fname = fname.replace(reg, '')
            // 终止循环
            throw new Error('break')
          }
        })
      } catch (err) {}
    }
    if (fname !== '') {
      const blob = new Blob([res.data])
      const downloadElement = document.createElement('a')
      const href = window.URL.createObjectURL(blob) // 创建下载的链接
      downloadElement.href = href
      // 预览二维码
      if (JSON.parse(res.config.data)?.params?.preview) {
        return href
      }
      downloadElement.download = decodeURIComponent(fname) // 下载后文件名
      document.body.appendChild(downloadElement)
      downloadElement.click() // 点击下载
      document.body.removeChild(downloadElement) // 下载完成移除元素
      window.URL.revokeObjectURL(href)
    } else {
      return URL.createObjectURL(res.data)
    }
  }
  else if (Object.prototype.toString.call(res.data) !== '[object Object]') {
    Message({ type: 'error', message: '返回数据异常' })
    return Promise.reject(new Error(res.data))
  } else if (res.data.code === 200) {
    if (res.config.formData) { // 这里的处理是因为wflow需要的数据结构是原始的，也是为了兼容手机端，wflow表单带带这个formData属性
      return res.data
    } else {
      return res.data.data
    }
  } else if (res.data.code === 100000) { // 可能token失效或者refreshToken失效
    Message({ type: 'error', message: '登录失效，请重新登录' })
    router.replace('/login')
    return Promise.reject(res.data)
  } else {
    Message({ type: 'error', message: res.data.message || '出现异常' })
    return Promise.reject(new Error(res.data.message))
  }
}, function (error) {
  return Promise.reject(error)
})

axios.downloadFile = (url, json, params) => {
  return axios({
    url,
    method: 'post',
    data: json,
    withCredentials: true,
    responseType: 'blob',
    params: params
  })
}

export default axios
